// src/Callback/Callback.js

import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom"
import { useAuth0 } from '@auth0/auth0-react'
import Cookies from 'js-cookie'

import Loading from 'components/Loading'
import api from 'lib/api'

const Callback = () => {
  const [message, setMessage] = useState('Loading')

  const navigate = useNavigate();

  const auth0 = useAuth0()

  const {
    isLoading,
    isAuthenticated,
    error,
    loginWithRedirect,
    getAccessTokenSilently
  } = auth0

  useEffect(() => {    
    const _checkLogin = async () => {
      try {
        const accessToken = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          },
        })
        if (accessToken) {
          const { user } = await api.users.auth({ token: accessToken })
          if (user) {
            Cookies.set('token', accessToken)
            let loc = window.localStorage.getItem('redirectLocation')
            if (loc) {
              window.localStorage.removeItem('redirectLocation')
              navigate(loc)
            } else {
              navigate('/dashboard')
            }
          } else {
            navigate('/?error=Error')
          }
        } else {
          console.log('Token Payload is not valid.')
        }
      } catch(e) {
        console.log(e)
        window.localStorage.setItem('redirectLocation', window.location.pathname)
        if (process.env.REACT_APP_BUILD === 'production') window.location = '/logout'
      }
    }
    
    if (!isLoading) {
      if (error) {
        setMessage('There was an error with login.')
      } else if (!isAuthenticated) {
        setMessage('Redirecting to Login')
        loginWithRedirect()
      } else if (isAuthenticated) {
        setMessage('Success! Redirecting...')
        _checkLogin()
      }
    }
  }, [isLoading, isAuthenticated, error, getAccessTokenSilently, navigate, loginWithRedirect])

  return <Loading text={message} isError={error} />
}

export default Callback